import { appConfig } from "src/config";
import { reroll } from "../components/PageSetRouter";
import { trackEvent } from "src/utils/api/tracker";

export default {
  userPortalHomePage() {
    window.location.href = appConfig.USERPORTAL_URL;
  },

  cancelSubscription(isHM: boolean, isInTrial: boolean, isInUpsEx233: boolean) {
    const program = isHM ? "/hm" : "";
    const cancelUrl = isInTrial ? "trial-cancel" : "cancel";

    let nextUrl = `/subscription${program}/${cancelUrl}`;
    if (isInUpsEx233) {
      nextUrl = `${nextUrl}?ee=1258`; // https://meristemstate.noom.com/experiment/1258
      trackEvent("UpsEx233CancelSubscriptionRedirect", {
        newUrl: nextUrl,
      });
    }
    reroll(nextUrl, new URLSearchParams(window.location.search), true);
  },
};
